module.exports = __webpack_public_path__ + "img/icon_mall_cn.fe457e0d.svg";